<template>
  <div class="logManagement" style="margin-top: 2%;width: 1440px;margin:0 auto;">
    <el-row justify="center" type="flex">
      <el-col>
        <el-form ref="queryForm" :model="queryForm" class="queryFormClass">
          <el-form-item label="User Name" prop="userName">
            <el-input v-model="queryForm.userName"></el-input>
          </el-form-item>
          <el-form-item label="Login IP" prop="loginIP">
            <el-input v-model="queryForm.loginIP"></el-input>
          </el-form-item>
          <el-form-item label="Operation" prop="operation">
          <el-select v-model="queryForm.operation" placeholder="Please choose...">
            <el-option
              v-for = "item in operations"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="Time Range" prop="time">
            <el-date-picker 
            v-model="queryForm.time" 
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator = "-"
            start-placeholder="start Time"
            end-placeholder="end Time"
            align="left"
            ></el-date-picker>
          </el-form-item>
          <el-button align="right" v-on:click="searchForm('queryForm')" type="primary">Search</el-button>
          <el-button align="right" v-on:click="resetForm('queryForm')" type="info" plain>Reset</el-button>
        </el-form>
        <el-table v-loading="pieLoading" :default-sort = "{prop: 'operTime', order: 'descending'}"
          :data="gridData">
          <el-table-column prop="operTime" label="Operation Time" align="left" sortable>
            <template  slot-scope="scope">
              <p>{{scope.row.operTime | timefilters}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="user_name" label="User Name" align="left"></el-table-column>
          <el-table-column prop="operType" label="Operation Type" align="left"></el-table-column>
          <el-table-column prop="remoteIP" label="Remote IP"  align="left"></el-table-column>
        </el-table>
        <el-pagination 
          background
          layout="total,prev,pager,next,jumper"
          :page-count="pageNumber"
          :current-page.sync="currentPage"
          @current-change ="currentPageChange"
          :page-size = "pageSize">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    export default {
      name: "viewLog",
      filters:{
        timefilters(val){
          if(val == null || val == ''){
            return ''
          }else{
            let d = new Date(val);
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() +1 ) : d.getMonth() + 1;
            let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
            let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
            let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
            let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
            let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
            return times;
          }
        }
      },
      data(){
          return {
            iconLoading:true,
            pieLoading:false,

            pageNumber:0,
            pageSize:8,
            currentPage:1,

            gridData: [],
            queryForm:{
              userName:'',
              loginName:'',
              loginIP:'',
              operation:'',
              time:[new Date().getTime() - 3600*1000*24,new Date().getTime()],
            },
            operations:[
              {value:'',
              label:'All'},
              {
              value:'LOGIN',
              label:'Login'
            },{
              value:'LOGOUT',
              label:'Logout'
            }],
            pickerOptions:{
              shortcuts:[{
                text:'最近一周',
                onClick(picker){
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600*1000*24*7);
                  picker.$emit('pick',[start,end]);
                }
              },{
                text:'最近一个月',
                onClick(picker){
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600*1000*24*30);
                  picker.$emit('pick',[start,end]);
                }
              },{
                text:'最近三个月',
                onClick(picker){
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600*1000*24*90);
                  picker.$emit('pick',[start,end]);
                }
              }]
            }
          }
      },
      mounted(){
          this.query();
      },
      methods:{
        
        query:function () {
          this.searchForm('queryForm');
        },
        currentPageChange:function(val){
          this.currentPage = val;
          this.queryLog();
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
          this.queryLog();
        },
        searchForm(formName) {
          this.currentPage = 1;
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.queryLog();
            }else {
              console.log('error search!!');
              return false;
            }
          });
        },
        queryLog:function(){
          let str = '';
          if(this.queryForm.userName){
            str+='&userName=' + this.queryForm.userName;
          }
          if(this.queryForm.loginName){
            str+='&loginName=' + this.queryForm.loginName;
          }
          if(this.queryForm.loginIP){
            str+='&loginIP=' + this.queryForm.loginIP;
          }
          if(this.queryForm.operation){
            str+='&operationType=' +  this.queryForm.operation;
          }
          let startTime = new Date(this.queryForm.time[0]);
          let endTime = new Date(this.queryForm.time[1]);
          str+='&startTime='+ startTime.format("yyyy-MM-dd hh:mm:ss");
          str+='&endTime='+ endTime.format("yyyy-MM-dd hh:mm:ss");
          this.$axios({ 
            method:'get',
            url:'/hlsTS/hlsii/userLog/page?pageNum=' + this.currentPage +'&pageSize='+ this. pageSize + str
          }).then((response) => {
            this.pageNumber =  Math.ceil(response.data.count / this.pageSize);
            this.gridData = response.data.operationLogList
          }).catch((error) => {
            this.gridData = []
          })
        }
      }
    }

</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .logManagement .el-form-item__label{width:110px;}
  .logManagement .el-form-item__content{margin-left:110px}
  .logManagement .queryFormClass .el-form-item{display: inline-block;}
  .logManagement .el-select{width:100%;}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/userManagement/viewLog.vue